import React, { useState } from 'react';

export const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter signup
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-emerald-800 text-white relative overflow-hidden">
      {/* Upper Section */}
      <div className="relative z-10 container mx-auto px-6 pt-16 pb-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          
          {/* Company Info */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold mb-4 text-white">EB Bright</h3>
            <p className="text-emerald-200 text-sm leading-relaxed mb-4">
              Professional painting, flooring, and insulation services across the Greater Toronto Area. 
              Quality craftsmanship you can trust since 2015.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-sm text-emerald-200">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:416-648-2980" className="hover:text-white transition-colors">416-648-2980</a>
              </div>
              <div className="flex items-center text-sm text-emerald-200">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:Nisar.noorzai@gmail.com" className="hover:text-white transition-colors break-all">
                  Nisar.noorzai@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-4 text-white uppercase tracking-wide text-xs">NEWSLETTER</h4>
            <p className="text-emerald-200 text-sm mb-4">
              Get tips, project ideas, and special offers delivered to your inbox.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-3">
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full bg-transparent border-b border-emerald-400 py-2 text-white placeholder-emerald-300 focus:outline-none focus:border-white transition-colors text-sm"
                  required
                />
                <button
                  type="submit"
                  className="absolute right-0 top-2 text-emerald-300 hover:text-white transition-colors"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </form>
            <p className="text-xs text-emerald-300 mt-2">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-4 text-white uppercase tracking-wide text-xs">QUICK LINKS</h4>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('services')}
                className="block text-emerald-200 hover:text-white transition-colors text-sm"
              >
                Our Services
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-emerald-200 hover:text-white transition-colors text-sm"
              >
                About Us
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="block text-emerald-200 hover:text-white transition-colors text-sm"
              >
                Customer Reviews
              </button>
              <button
                onClick={() => scrollToSection('quote')}
                className="block text-emerald-200 hover:text-white transition-colors text-sm"
              >
                Free Quote
              </button>
            </div>
          </div>

          {/* Connect */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-4 text-white uppercase tracking-wide text-xs">CONNECT</h4>
            <div className="space-y-3">
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
              <div className="text-emerald-200 text-sm">
                <p className="mb-2">Service Areas:</p>
                <p className="text-xs">North York • Scarborough • Markham</p>
                <p className="text-xs">Richmond Hill • Vaughan • Mississauga</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-emerald-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-emerald-300 mb-4 md:mb-0">
              <p>&copy; 2024 EB Bright Painting and Decoration Service Company. All rights reserved.</p>
            </div>
            <div className="text-sm text-emerald-300">
              <a href="https://www.ebbright.com" className="hover:text-white transition-colors">
                Outsmart Technologies
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Large Branding Background */}
      <div className="absolute bottom-0 left-0 right-0 h-2/3 flex items-end justify-center overflow-hidden pointer-events-none">
        <div className="text-emerald-200 opacity-5 font-black text-9xl lg:text-[12rem] leading-none tracking-tight">
          EB BRIGHT
        </div>
      </div>
    </footer>
  );
};
